<template>
  <div id="preloader">
    <div class="cts-loader2" :style="{ '--cts-size': size }" role="status" aria-label="Loading">
      <svg viewBox="0 0 1024 1024" aria-hidden="true">
        <circle class="arc a1" cx="512" cy="517" r="455" pathLength="100" />
        <circle class="arc a2" cx="512" cy="517" r="370" pathLength="100" />
        <circle class="arc a3" cx="512" cy="517" r="290" pathLength="100" />
        <path class="swoosh outer" fill-rule="evenodd" d="M468.5 1003.4C406.6 999.6 354.1 988.3 300.5 967.3C268.9 954.9 224.5 931.1 197.0 911.8C150.9 879.4 110.2 839.5 77.7 794.7C62.9 774.4 39.1 735.0 41.7 735.0C42.1 735.0 43.5 736.7 44.6 738.8C48.2 745.0 62.5 764.7 72.8 777.5C84.6 792.1 111.6 819.9 126.4 832.7C157.3 859.3 192.2 882.1 228.5 899.6C390.1 977.2 585.0 958.1 726.1 850.9C811.8 785.7 869.3 694.7 888.9 593.0C898.1 545.5 898.2 493.4 889.4 445.0C863.1 301.3 759.0 178.7 615.0 122.1C532.8 89.7 442.7 80.5 355.0 95.6C248.7 113.8 152.7 166.7 83.7 245.0C71.9 258.4 55.6 279.7 47.5 292.2C36.3 309.6 42.6 295.3 55.7 273.7C76.5 239.3 98.7 211.2 129.0 181.0C160.4 149.5 188.7 127.3 226.0 105.0C291.2 65.8 361.6 42.7 442.5 33.8C458.8 32.0 528.2 32.0 544.5 33.8C607.3 40.7 660.4 55.1 714.1 80.0C794.7 117.2 865.3 176.6 915.4 249.0C1019.1 398.8 1027.5 594.4 937.1 751.9C856.3 892.7 710.5 985.2 543.5 1001.5C528.2 1003.0 481.2 1004.2 468.5 1003.4Z" />
        <path class="swoosh inner" fill-rule="evenodd" d="M417.6 920.9C231.2 907.6 75.4 776.3 37.5 600.4C30.9 570.0 29.6 555.7 29.5 518.5C29.5 484.0 30.1 476.3 34.6 450.2C53.1 342.5 117.9 245.3 212.5 183.5C294.2 130.1 388.6 106.7 488.5 115.1C620.5 126.2 741.9 199.5 810.6 309.7C818.5 322.3 826.4 337.0 825.3 337.0C824.9 336.9 821.8 332.8 818.5 327.7C794.5 290.9 757.3 254.1 717.5 227.5C622.5 164.2 505.7 145.0 393.2 174.1C322.5 192.4 254.0 233.4 206.7 285.8C156.5 341.3 127.5 403.2 117.4 476.5C114.8 494.6 114.8 541.0 117.3 559.0C126.6 625.5 151.7 683.2 193.8 734.7C232.7 782.2 285.8 821.1 345.0 845.3C349.7 847.3 358.9 851.1 365.5 854.0C397.9 868.0 436.8 877.7 473.8 881.0C491.1 882.6 536.3 881.8 552.0 879.6C593.8 873.7 629.5 862.6 667.0 843.9C709.1 822.8 742.1 797.4 777.1 759.0C794.3 740.1 808.1 723.1 817.9 708.7C821.9 702.7 825.4 698.1 825.7 698.3C826.5 699.1 813.4 721.6 803.4 736.5C798.3 744.3 789.2 756.6 783.4 764.0C769.7 781.3 736.5 814.4 719.0 828.4C672.0 865.9 617.7 893.0 559.6 908.0C513.9 919.8 464.6 924.3 417.6 920.9Z" />
        <path class="letter c" fill-rule="evenodd" d="M467.3 880.4C435.7 877.0 404.3 869.3 374.9 857.9C361.8 852.8 357.6 850.3 368.6 854.0C388.2 860.8 422.1 868.4 446.0 871.4C455.9 872.7 489.2 874.9 498.2 875.0C499.6 875.0 500.0 875.8 500.0 878.5L500.0 882.0L489.8 881.9C484.1 881.8 474.0 881.2 467.3 880.4ZM257.5 685.1C250.9 682.0 242.5 673.9 239.2 667.4C233.8 656.8 233.9 659.7 234.2 561.9L234.5 471.5L237.3 465.5C238.9 462.2 241.3 458.2 242.8 456.7C256.7 442.0 284.9 436.6 335.8 438.9C348.9 439.5 367.0 440.3 376.2 440.7L393.0 441.3L393.0 477.0C393.0 503.3 392.7 512.9 391.8 513.8C390.9 514.7 384.8 515.0 370.3 515.0L350.0 515.0L350.0 505.0L350.0 495.0L329.0 495.0L308.0 495.0L308.0 568.5L308.0 642.0L364.5 642.0L421.0 642.0L421.0 665.0L421.0 688.0L342.2 688.0L263.5 688.0L257.5 685.1Z" />
        <path class="letter s" fill-rule="evenodd" d="M500.0 878.8C500.0 874.5 501.1 874.0 512.5 874.0C532.1 874.0 565.7 869.3 591.3 863.1C657.8 847.0 717.8 814.6 767.0 768.4C776.3 759.7 776.4 759.7 770.1 766.5C742.2 797.2 705.7 824.6 667.0 843.9C618.6 868.0 571.5 880.2 520.2 881.7L500.0 882.3L500.0 878.8ZM604.0 664.1L604.0 641.2L642.2 640.7C684.0 640.3 687.2 639.9 697.5 634.1C708.8 627.8 714.9 613.0 715.0 591.8L715.0 586.0L691.6 586.0C671.1 586.0 667.4 585.8 661.9 584.0C650.7 580.5 641.5 571.8 636.8 560.3C634.5 554.5 634.5 554.3 634.5 511.0L634.5 467.5L637.4 461.7C641.1 454.1 650.3 444.7 657.1 441.5L662.5 439.0L728.2 439.0L794.0 439.0L794.0 476.0L794.0 513.0L771.0 513.0L748.0 513.0L748.0 503.0L748.0 493.0L729.5 493.0L711.0 493.0L711.0 512.5L711.0 531.9L750.8 532.2C782.8 532.4 791.0 532.8 792.3 533.9C793.8 535.1 794.0 539.6 794.0 579.7C794.0 630.2 793.8 632.4 786.5 647.5C776.8 667.6 758.7 682.3 738.6 686.1C735.9 686.6 704.8 687.0 668.9 687.0L604.0 687.0L604.0 664.1Z" />
        <path class="arrow" fill-rule="evenodd" d="M505.0 688.4C469.2 684.2 447.9 672.5 437.6 651.5C433.3 642.7 431.3 635.1 429.9 621.6C426.5 589.2 438.3 534.6 463.9 464.5C468.4 452.4 472.0 442.2 472.0 441.8C472.0 441.3 460.6 441.0 446.8 441.0C422.2 441.0 421.6 441.0 423.5 439.1C426.3 436.5 551.5 347.1 553.2 346.6C554.0 346.3 564.8 358.9 581.5 379.7C596.4 398.1 613.4 419.3 619.4 426.7C625.3 434.1 630.0 440.3 629.8 440.5C629.6 440.8 618.8 441.5 605.9 442.1C593.1 442.8 581.6 443.7 580.4 444.1C578.9 444.6 576.5 449.7 570.6 464.7C537.3 549.2 523.4 602.5 527.0 631.4C528.9 647.0 533.6 655.9 543.3 662.1C552.1 667.8 560.7 669.4 579.3 668.7L594.2 668.2L593.5 676.4C593.1 680.8 592.6 684.7 592.4 684.9C590.4 687.0 517.8 689.9 505.0 688.4Z" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "PPHLoader",

  props: {
    size: { type: String, default: "120px" },
  },

  mounted() {
    const wrapper = document.querySelector('.app-content-wrapper');
    if (wrapper) wrapper.style.overflow = 'hidden';
  },

  unmounted() {
    const wrapper = document.querySelector('.app-content-wrapper');
    if (wrapper) wrapper.style.overflow = '';
  },
};
</script>

<style scoped>
#preloader {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent white background */
  z-index: 1000;
}

/* CTS loader v2 — rings chase → logo assembles → hold → repeat */
.cts-loader2 {
  --cts-blue: #009FE3;
  --cts-red: #E30016;
  --cts-cycle: 5s;
  width: var(--cts-size); height: var(--cts-size); display: inline-block;
}
.cts-loader2 svg { width: 100%; height: 100%; overflow: visible; }
.cts-loader2 * { animation-duration: var(--cts-cycle); animation-iteration-count: infinite; animation-fill-mode: both; }

/* Phase 1: three partial rings chase each other */
.cts-loader2 .arc { fill: none; stroke-linecap: round; transform-origin: 512px 517px; }
.cts-loader2 .arc.a1 { stroke: var(--cts-blue); stroke-width: 58; animation-name: cts2-a1; }
.cts-loader2 .arc.a2 { stroke: var(--cts-blue); stroke-width: 48; animation-name: cts2-a2; }
.cts-loader2 .arc.a3 { stroke: var(--cts-red);  stroke-width: 40; animation-name: cts2-a3; }

@keyframes cts2-a1 {
  0%   { transform: rotate(0deg);    stroke-dasharray: 8 92;  opacity: 0; animation-timing-function: cubic-bezier(.5,0,.3,1); }
  4%   { opacity: 1; }
  22%  { stroke-dasharray: 38 62; }
  42%  { transform: rotate(720deg);  stroke-dasharray: 20 80; opacity: 1; }
  50%  { transform: rotate(760deg) scale(1.06); opacity: 0; }
  100% { transform: rotate(760deg); opacity: 0; }
}
@keyframes cts2-a2 {
  0%, 6% { transform: rotate(-120deg); stroke-dasharray: 8 92; opacity: 0; animation-timing-function: cubic-bezier(.5,0,.3,1); }
  10%  { opacity: 1; }
  27%  { stroke-dasharray: 34 66; }
  45%  { transform: rotate(-840deg); stroke-dasharray: 18 82; opacity: 1; }
  53%  { transform: rotate(-880deg) scale(.94); opacity: 0; }
  100% { transform: rotate(-880deg); opacity: 0; }
}
@keyframes cts2-a3 {
  0%, 12% { transform: rotate(120deg); stroke-dasharray: 8 92; opacity: 0; animation-timing-function: cubic-bezier(.5,0,.3,1); }
  16%  { opacity: 1; }
  32%  { stroke-dasharray: 30 70; }
  47%  { transform: rotate(840deg); stroke-dasharray: 6 94; opacity: 1; }
  54%  { transform: rotate(870deg) scale(.4); opacity: 0; }
  100% { transform: rotate(870deg); opacity: 0; }
}

/* Phase 2: rings settle into the logo, then hold */
.cts-loader2 .swoosh { fill: var(--cts-blue); }
.cts-loader2 .swoosh.outer { transform-origin: 514px 517px; animation-name: cts2-outer; }
.cts-loader2 .swoosh.inner { transform-origin: 505px 522px; animation-name: cts2-inner; }
.cts-loader2 .letter { fill: var(--cts-blue); }
.cts-loader2 .letter.c { animation-name: cts2-c; }
.cts-loader2 .letter.s { animation-name: cts2-s; }
.cts-loader2 .arrow { fill: var(--cts-red); animation-name: cts2-arrow; }

@keyframes cts2-outer {
  0%, 42% { transform: rotate(-200deg) scale(1.08); opacity: 0; animation-timing-function: cubic-bezier(.2,.8,.2,1); }
  58%     { transform: rotate(0deg) scale(1); opacity: 1; }
  90%     { transform: rotate(0deg) scale(1); opacity: 1; }
  100%    { transform: rotate(40deg) scale(1.04); opacity: 0; }
}
@keyframes cts2-inner {
  0%, 45% { transform: rotate(220deg) scale(.9); opacity: 0; animation-timing-function: cubic-bezier(.2,.8,.2,1); }
  60%     { transform: rotate(0deg) scale(1); opacity: 1; }
  90%     { transform: rotate(0deg) scale(1); opacity: 1; }
  100%    { transform: rotate(-40deg) scale(.96); opacity: 0; }
}
@keyframes cts2-c {
  0%, 52% { transform: translateX(-90px); opacity: 0; animation-timing-function: cubic-bezier(.2,.9,.3,1.3); }
  62%     { transform: translateX(0); opacity: 1; }
  90%     { transform: translateX(0); opacity: 1; }
  100%    { transform: translateX(0); opacity: 0; }
}
@keyframes cts2-s {
  0%, 54% { transform: translateX(90px); opacity: 0; animation-timing-function: cubic-bezier(.2,.9,.3,1.3); }
  64%     { transform: translateX(0); opacity: 1; }
  90%     { transform: translateX(0); opacity: 1; }
  100%    { transform: translateX(0); opacity: 0; }
}
/* the red ring collapses and shoots up as the arrow */
@keyframes cts2-arrow {
  0%, 54% { transform: translateY(160px); opacity: 0; animation-timing-function: cubic-bezier(.2,.9,.3,1.25); }
  66%     { transform: translateY(0); opacity: 1; }
  74%     { transform: translateY(-14px); }
  80%, 90% { transform: translateY(0); opacity: 1; }
  100%    { transform: translateY(0); opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .cts-loader2 * { animation: none !important; }
  .cts-loader2 .arc { display: none; }
}
</style>
